import PropTypes from "prop-types";
import React from "react";

const Alert = (props) => {
  const { type, title = "", items = [], children } = props;

  let arrayItems = items;
  if (!Array.isArray(arrayItems)) {
    arrayItems = [items];
  }

  return (
    <div className={`fr-alert fr-alert--${type}`}>
      {title && <h3 className="fr-alert__title">{title}</h3>}
      {arrayItems.length > 0 ? arrayItems : children}
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  items: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

export default Alert;
